import { render, staticRenderFns } from "./documents-preview.vue?vue&type=template&id=4a8e09a5&scoped=true&"
import script from "./documents-preview.vue?vue&type=script&lang=js&"
export * from "./documents-preview.vue?vue&type=script&lang=js&"
import style0 from "./documents-preview.vue?vue&type=style&index=0&id=4a8e09a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8e09a5",
  null
  
)

export default component.exports